import { createFileRoute } from '@tanstack/react-router';
import { WhatsOnEventSessionPage } from '../../../../features/whats-on/routes/WhatsOnEventSessionPage';

export const Route = createFileRoute('/whats-on/$token/sessions/$sessionId')({
    component: WhatsOnEventSessionPage,
    params: {
        parse: (params) => {
            return { sessionId: parseInt(params.sessionId, 10), token: params.token };
        },
        stringify: (value) => {
            return { sessionId: value.sessionId.toString(), token: value.token };
        },
    },
})
